
import {HoverCard, HoverCardType, IPlainCardProps, IExpandingCardProps, Icon, Checkbox} from '@fluentui/react';
import React, { Component } from 'react';

class TemplHoverCard extends Component {
    render() {  
      
      const itemDetails = {
        title: <h3>{this.props.name}</h3>,
        description: <div dangerouslySetInnerHTML={{__html: this.props.description}}></div>,
        imageUrl: this.props.imageUrl
      };

        // const itemDetails1 = this.props.type === SiteType.teamSite_display
        //   ? { 
        //     imageUrl:
        //     "https://spoprod-a.akamaihd.net/files/odsp-next-prod_2019-05-31-sts_20190605.001/odsp-media/images/designpackage/teamsite.png",
        //     description: <div>Connect people content, information, and apps your team use to collaborate, including having conversation with your team and managing tasks. 
        //       <p>With Team Site you will be able to use:</p>
        //       <ul>
        //         <li>Planner</li>
        //         <li>Outlook</li>
        //         <li>Group Calendar</li>
        //         <li>MS Teams</li>
        //         <li>More</li>
        //       </ul></div>,
        //     title: <h3>{this.props.type}</h3>
        //   }
        //   : 
        //     (this.props.type ===  SiteType.communicationSite_display 
        //       ? {
        //         title: <h3>{this.props.type}</h3>,
        //         description: <div><p>Share news, reports, statuses with broader audience in a visually compelling format. Communication sites are responsive and can be viewed from anywhere on any device. Especially used to keep people informed and engaged in topics, events and projects. </p></div>,
        //         imageUrl: "https://spoprod-a.akamaihd.net/files/odsp-next-prod_2019-05-31-sts_20190605.001/odsp-media/images/designpackage/reportsite.png",
        //       } 
        //       : null
        //     )
      
          const rootStyle = { width: "380px" };
      
          const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: this.renderCompactCard,
            onRenderExpandedCard: this.renderExpandedCard,
            renderData: itemDetails,
            compactCardHeight: 156,
            expandedCardHeight: 'max-content',
            styles: { root: rootStyle}
          };

          const plainCardProps: IPlainCardProps = {
            onRenderPlainCard: this.renderExpandedCard,
            renderData: itemDetails,
            plainCardHeight: 'max-content',
            styles: { root: rootStyle }
          };

          return (
            <div style={hoverCardStyles}>
                <HoverCard
                    expandingCardProps={expandingCardProps}
                    expandedCardOpenDelay='300'
                    cardDismissDelay='300'
                    instantOpenOnClick={true}
                    type={HoverCardType.expanding} //HoverCardType.plain
                    plainCardProps={plainCardProps}
                    >
                        <Icon style={iconStyles} iconName='info' />
                </HoverCard>
            </div>
          );
        }

      pickTemplate = () => {
        this.props.pickTemplate(this.props.id);
      }
      
      renderExpandedCard = item => {
        return (
            <div style={expandedCardStyles}>
                {item.title}
                {item.description}
                <div className="hover-card-checkbox"><Checkbox checked={this.props.selected} onChange={this.pickTemplate}/></div>
            </div>
            
        );
      };
    
      renderCompactCard = item => {
        return (
          <div>
            <div style={{minHeight: '1000px'}}> {/* Quick fix for not displaying whole description when img is small*/}
              <img src={item.imageUrl} style={imgStyles} alt='Template' />
            </div>
          </div>
        );
      };

    }


const hoverCardStyles = {
  verticalAlign: 'middle',
  display: 'flex'
};

const iconStyles = {
  margin: '3px 5px',
  cursor: 'pointer'
}

const imgStyles = {
  width: '380px', 
  position: 'absolute', 
  clip: 'rect(0px,400px,156px,0px)'
}

const expandedCardStyles = {
  marginTop: '3px',
  padding: '15px',
  borderTop: '3px solid #F4F4F4'
}


export default TemplHoverCard


// WEBPACK FOOTER //
// ./src/components/formFields/TemplHoverCard.js